import { render } from "./QuizItemGradeSelect.vue?vue&type=template&id=2512fa0c"
import script from "./QuizItemGradeSelect.vue?vue&type=script&lang=js"
export * from "./QuizItemGradeSelect.vue?vue&type=script&lang=js"

import "./QuizItemGradeSelect.vue?vue&type=style&index=0&id=2512fa0c&lang=css"

import exportComponent from "/Users/ruwan/projects/eopp/eopp-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__